import { Button, Stack } from "@mui/material";
import { Box } from "@mui/system";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { HeaderConditionType } from "./BaseFilter";
import { GroupFilter, GroupFilterOption } from "./GroupFilter";
import { UsernameFilter, UserFilterOption } from "./UsernameFilter";

export interface HeaderFilterValue {
    usernameFilter?: UsernameFilter
    groupFilter?: GroupFilter
}

interface HeaderFilterProps {
    onApply: (filter: HeaderFilterValue) => void
    handleClose: () => void
}

export function HeaderFilter(props: HeaderFilterProps) {
    const [usernameFilter, setUsernameFilter] = useState<UsernameFilter>();
    const [groupFilter, setGroupFilter] = useState<GroupFilter>();

    const validate = (g?: GroupFilter | UsernameFilter) => {
        if(!g) {
            return false;
        }

        if (g.conditionType === HeaderConditionType.Empty) {
            return false;
        }

        if(g.filter.trim() === "") {
            return false;
        }

        return true;
    };


    return (<>
        <Stack sx={{ flex: 1, height: "100%", marginTop: "10px", marginLeft: "20px", marginRight: "20px", marginBottom: "20px" }}>
            <GroupFilterOption id="group-filter-toggle" setState={setGroupFilter} state={groupFilter} />
            <UserFilterOption id="username-filter-toggle" setState={setUsernameFilter} state={usernameFilter} />
            <Box display="flex" sx={{ marginTop: "40px" }}>
                <Button
                    id="cancel-header-filter-button"
                    variant="outlined"
                    size="medium"
                    onClick={props.handleClose}
                >
                    Cancel
                </Button>
                <LoadingButton
                    id="apply-header-filter-button"
                    sx={{ marginLeft: "auto" }}
                    variant="contained"
                    size="medium"
                    onClick={() => {
                        props.onApply({
                            groupFilter: validate(groupFilter) ? groupFilter : undefined,
                            usernameFilter: validate(usernameFilter) ? usernameFilter : undefined,
                        });

                        props.handleClose();
                    }}
                >
                    Apply Filters
                </LoadingButton>
            </Box>
        </Stack>
    </>);
}



